import React, { useEffect } from 'react'
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material'
import { useGetBusinessByUserQuery } from '../../store/api/businessApi'
import { useDispatch } from 'react-redux'
import { updateBuCodeData, updateBuData } from '../../store/slice/persistSlice'

const BusinessUnit = ({ value, setValue, errors, setCode, notFullWidth, disabled, setBusinessUnitData, label }) => {
  const { data, isLoading } = useGetBusinessByUserQuery()
  const dispatch = useDispatch()

  const handleChange = (value) => {
    setValue(value)
    value && setCode && setCode(data?.data?.find((item) => item.businessUnitId === value)?.businessUnitCode)
    dispatch(updateBuData(value))
    dispatch(updateBuCodeData(data?.data?.find((item) => item.businessUnitId === value)?.businessUnitCode))
  }


  useEffect(() => {
    dispatch(updateBuData(value))
    value && setCode && setCode(data?.data?.find((item) => item.businessUnitId === value)?.businessUnitCode)
    setValue && setValue(value)
  }, [value])

  useEffect(() => {
    if (setBusinessUnitData && data?.data) {
      setBusinessUnitData(data?.data)
    }
  }, [data])

  return (
    <FormControl size="small" fullWidth={!notFullWidth} sx={notFullWidth ? { width: '93%' } : {}}>
      <InputLabel>{label ?? 'Business Unit'}</InputLabel>
      <Select
        disabled={disabled}
        error={Boolean(errors?.businessUnitId)}
        label={label ?? 'Business Unit'}
        value={value || ''}
        style={{
          color: disabled && 'black !important',
          background: disabled && 'hsl(0, 0%, 95%)',
        }}
        onChange={(e) => handleChange(e.target.value)}
      >
        {!isLoading &&
          data?.data.map((item, index) => (
            <MenuItem key={index} value={item.businessUnitId}>
              {item.businessUnitName}
            </MenuItem>
          ))}
      </Select>
      {errors?.businessUnitId && (
        <FormHelperText sx={{ color: '#d32f2f', ml: 0 }}>{errors?.businessUnitId.message || 'Required'}</FormHelperText>
      )}
    </FormControl>
  )
}

export default BusinessUnit